import ui from './ui';
import shared from './shared';
import domains from '../domain';

const registry = {
    ...ui,
    ...shared,
    ...domains,
};

export default registry;